"use strict";

exports.__esModule = true;
exports.isRedirectsNotSet = exports.isContentMigrationAdminControlsEnabled = exports.isContentMigrationEnabled = exports.isFirstTime = exports.isRedirectsSet = exports.isPostsTransfered = exports.getContentMigrationFailedPosts = exports.getContentMigrationStatus = exports.getContentMigration = void 0;

var _communitiesBlogExperiments = require("@wix/communities-blog-experiments");

var _experimentsSelectors = require("./experiments-selectors");

var _migrationStatus = require("../constants/migration-status");

var getContentMigration = function getContentMigration(state) {
  return state.contentMigration;
};

exports.getContentMigration = getContentMigration;

var getContentMigrationStatus = function getContentMigrationStatus(state) {
  return getContentMigration(state).status;
};

exports.getContentMigrationStatus = getContentMigrationStatus;

var getContentMigrationFailedPosts = function getContentMigrationFailedPosts(state) {
  return getContentMigration(state).failedPosts || [];
};

exports.getContentMigrationFailedPosts = getContentMigrationFailedPosts;

var isPostsTransfered = function isPostsTransfered(state) {
  return getContentMigrationStatus(state) === _migrationStatus.MIGRATION_STATUS_CONTENT_SYNC_COMPLETE;
};

exports.isPostsTransfered = isPostsTransfered;

var isRedirectsSet = function isRedirectsSet(state) {
  return getContentMigrationStatus(state) === _migrationStatus.MIGRATION_STATUS_REDIRECTS_SET_COMPLETE;
};

exports.isRedirectsSet = isRedirectsSet;

var isFirstTime = function isFirstTime(state) {
  return getContentMigration(state).isFirstTime;
};

exports.isFirstTime = isFirstTime;

var isSyncOrRedirectComplete = function isSyncOrRedirectComplete(state) {
  return [_migrationStatus.MIGRATION_STATUS_CONTENT_SYNC_COMPLETE, _migrationStatus.MIGRATION_STATUS_REDIRECTS_SET_COMPLETE].includes(getContentMigrationStatus(state));
};

var isContentMigrationEnabled = function isContentMigrationEnabled(state) {
  return getContentMigration(state).isOldBlogInstalled || isSyncOrRedirectComplete(state);
};

exports.isContentMigrationEnabled = isContentMigrationEnabled;

var isContentMigrationAdminControlsEnabled = function isContentMigrationAdminControlsEnabled(state) {
  return isContentMigrationEnabled(state) && (0, _experimentsSelectors.isExperimentEnabled)(state, _communitiesBlogExperiments.EXPERIMENT_CONTENT_MIGRATION_ADMIN) && _migrationStatus.MIGRATION_ROLLBACK_ALLOWED_STATUSES.includes(getContentMigrationStatus(state));
};

exports.isContentMigrationAdminControlsEnabled = isContentMigrationAdminControlsEnabled;

var isRedirectsNotSet = function isRedirectsNotSet(state) {
  return _migrationStatus.MIGRATION_REDIRECTS_PENDING_STATUSES.includes(getContentMigrationStatus(state));
};

exports.isRedirectsNotSet = isRedirectsNotSet;